import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type Status = "success" | "error" | "warning" | "";

interface DialogState {
  openDialog: boolean;
  dialogStatus?: Status;
  dialogTitle?: string;
  dialogDescription?: string;
}

const initialState: DialogState = {
  openDialog: false,
  dialogStatus: "",
  dialogTitle: "",
  dialogDescription: "",
};

export const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    setOpenDialog: (state, action: PayloadAction<boolean>) => {
      state.openDialog = action.payload;
    },

    setDialogStatus: (state, action: PayloadAction<Status>) => {
      state.dialogStatus = action.payload;
    },
    setDialogTitle: (state, action: PayloadAction<string>) => {
      state.dialogTitle = action.payload;
      state.dialogDescription = "";
    },
    setDialogDescription: (state, action: PayloadAction<string>) => {
      state.dialogDescription = action.payload || "";
    },
  },
});

// export const getDialogState = (state: RootState) => state.snackbar;

export const {
  setDialogDescription,
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} = dialogSlice.actions;

export default dialogSlice.reducer;
